import React, { useCallback, useContext, useEffect, useState } from "react";
import { events, invoke, showFlag } from "@forge/bridge";
import ReactDOM from "react-dom";
import sortBy from "lodash/sortBy";
import { v4 as uuid } from "uuid";
import debounce from "lodash.debounce";
import { useTranslation } from "react-i18next";
import { AppContext } from "../Context";
import { Entry } from "../ForgeContextWrapper";
import Banner from "../Shared/Components/banner/Banner";
import { documentReady } from "../Shared/functions";

function PortalHeader() {
  const { generalStyling } = useContext(AppContext);
  const [catalog, setCatalog] = useState();
  const [requestCounter, setRequestCounter] = useState(0);

  const [cart, setCart] = useState({});

  const { t } = useTranslation();

  useEffect(() => {
    events.on("SET_CATALOG", (payload) => setCatalog(payload.catalog));
    events.on("SET_CART", (payload) => setCart(payload?.cart));
  }, []);

  useEffect(() => {
    if (requestCounter >= 5) return;
    if (requestCounter === 0) {
      setTimeout(() => {
        if (!catalog) events.emit("REQUEST_CATALOG");
        if (!cart) events.emit("REQUEST_CART");
      }, 100);
    } else {
      if (!catalog) events.emit("REQUEST_CATALOG");
      if (!cart) events.emit("REQUEST_CART");
    }
    setTimeout(() => {
      setRequestCounter(requestCounter + 1);
    }, (requestCounter + 1) * 150);
  }, [requestCounter]);

  if (!catalog?.id) return <></>;

  return (
    <Banner
      isOnJSM
      config={{
        ...(catalog?.catalogBanner || {}),
        currency: catalog?.currency,
      }}
      globalConfig={{ ...(generalStyling?.bannerConfig || {}) }}
      cart={cart}
      useNoBackgroundStyling
    />
  );
}

documentReady(() => {
  ReactDOM.render(
    <Entry
      showSpinnerWhileLoading={false}
      requiresLicense
      initFunctions={[{ name: "generalStyling", fKey: "getGeneralStyling" }]}
    >
      <PortalHeader />
    </Entry>,
    document.getElementById("root")
  );
});
